import jsBarcode from 'jsbarcode'
const CLASS_NAME_BARCODE = 'js-barcode'

document.addEventListener('DOMContentLoaded', () => {
  const elementsBarcode = document.getElementsByClassName(CLASS_NAME_BARCODE)
  if (elementsBarcode.length) {
    Array.from(elementsBarcode).forEach((element) => {
      const codeId = element.dataset.codeId
      const lineColor = element.dataset.lineColor || '#000'
      if (!codeId) return
      jsBarcode(`#js-barcode-${codeId}`, codeId, {
        format: 'EAN13',
        displayValue: false,
        width: 3.3,
        flat: true,
        lineColor,
      })

      jsBarcode(`#js-barcode-modal-${codeId}`, codeId, {
        format: 'EAN13',
        displayValue: false,
        width: Number((window.innerHeight / 130).toFixed(1)),
        height: window.innerWidth * 0.5,
        flat: true,
      })

      const elementModalBarcode = document.getElementById(
        `js-modalBarcode-${codeId}`
      )
      element.addEventListener('click', () => {
        elementModalBarcode.classList.add('is-show')
      })
      elementModalBarcode.addEventListener('click', () => {
        elementModalBarcode.classList.remove('is-show')
      })
    })
  }
})
